module.exports = __webpack_public_path__ + "media/img/frontend_application/Bannerdesktop-cdbc5fef76e91010782bc625483b2a35.png";